import { CommonModule } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { RouterLink } from '@angular/router';
import { CapteurLivraisonItem, CapteursService } from '../../../services/capteurs.service';

@Component({
  selector: 'app-capteurs-en-cours-livraison',
  imports: [CommonModule, RouterLink],
  templateUrl: './capteurs-en-cours-livraison.component.html',
  styleUrl: './capteurs-en-cours-livraison.component.scss'
})
export class CapteursEnCoursLivraisonComponent implements OnInit {
  protected loading = false;
  protected error = '';
  protected items: CapteurLivraisonItem[] = [];

  constructor(
    private readonly capteursService: CapteursService,
    private readonly cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.load();
  }

  protected refresh(): void {
    this.load();
  }

  private load(): void {
    this.loading = true;
    this.error = '';
    this.cdr.markForCheck();

    this.capteursService.listEnCoursDeLivraison().subscribe({
      next: (items: CapteurLivraisonItem[]) => {
        this.items = items;
        this.loading = false;
        this.cdr.markForCheck();
      },
      error: (err: HttpErrorResponse) => {
        this.items = [];
        this.error = this.getErrorMessage(err);
        this.loading = false;
        this.cdr.markForCheck();
      }
    });
  }

  protected formatCartouches(item: CapteurLivraisonItem): string {
    return [item.cartouche_a_nom, item.cartouche_b_nom].filter((value): value is string => !!value).join(' / ');
  }

  private getErrorMessage(err: HttpErrorResponse): string {
    if (typeof err.error === 'string' && err.error.trim()) {
      return err.error;
    }
    if (err.error?.detail) {
      return String(err.error.detail);
    }
    if (err.error?.message) {
      return String(err.error.message);
    }
    return err.statusText || 'Erreur inconnue';
  }
}
